import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const FlashesList = () => {
    const [flashes, setFlashes] = useState([]);
    const [filteredFlashes, setFilteredFlashes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}flashes`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setFlashes(data.data);
                    setFilteredFlashes(data.data);
                } else {
                    console.error('Error fetching flashes:', data.message);
                }
            })
            .catch(error => console.error('Error fetching flashes:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = flashes.filter(flash =>
            flash.customer_name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredFlashes(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditFlash/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this flash?")) {
            fetch(`${BASE_URL}flashes/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setFlashes(flashes.filter(flash => flash.id !== id));
                        setFilteredFlashes(filteredFlashes.filter(flash => flash.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting flash:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Flashes List</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddFlash')}>Add Flash</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Customer Name</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search customer name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Customer Name</th>
                                                <th>PCS</th>
                                                <th>Gross Weight</th>
                                                <th>Description</th>
                                                <th>Created At</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredFlashes.map(flash => (
                                                <tr key={flash.id}>
                                                    <td>{flash.id}</td>
                                                    <td>{flash.customer_name}</td>
                                                    <td>{flash.pcs}</td>
                                                    <td>{flash.gross_weight}</td>
                                                    <td>{flash.description}</td>
                                                    <td>{new Date(flash.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(flash.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(flash.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FlashesList;
